export function RightIcon() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_4961_20326)">
                <rect width="68.2852" height="68.2852" rx="34.1426" fill="url(#paint0_linear_4961_20326)" />
                <g filter="url(#filter1_i_4961_20326)">
                    <path
                        d="M48.7978 26.1923L30.982 44.008C30.3259 44.6639 29.266 44.6757 28.5951 44.0347L19.4844 35.3297L21.8435 32.8606L29.7469 40.4115L46.382 23.7776L48.7978 26.1923Z"
                        fill="url(#paint1_linear_4961_20326)"
                    />
                </g>
            </g>
            <defs>
                <filter id="filter0_i_4961_20326" x="0" y="0" width="68.5575" height="68.2852" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.27238" />
                    <feGaussianBlur stdDeviation="0.749989" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.404601 0 0 0 0 0.301695 0 0 0 0 0.0392843 0 0 0 0.54 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4961_20326" />
                </filter>
                <filter
                    id="filter1_i_4961_20326"
                    x="19.4844"
                    y="23.7776"
                    width="29.6236"
                    height="20.7302"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.31009" />
                    <feGaussianBlur stdDeviation="0.31009" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.291617 0 0 0 0 0.291617 0 0 0 0 0.291617 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4961_20326" />
                </filter>
                <linearGradient id="paint0_linear_4961_20326" x1="44.0586" y1="64.7532" x2="19.9613" y2="8.44603" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7EDD3" />
                    <stop offset="0.872251" stopColor="#F2E2B9" />
                </linearGradient>
                <linearGradient id="paint1_linear_4961_20326" x1="-47.8129" y1="90.8013" x2="32.1824" y2="7.94413" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0144231" stopColor="#9C6F08" />
                    <stop offset="0.39409" stopColor="#EAC360" />
                    <stop offset="1" stopColor="#9F740F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysSignUpIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28" fill="none">
            <g filter="url(#filter0_di_5182_159309)">
                <path
                    d="M12.4512 2.31873C15.908 2.31873 18.7109 5.12164 18.7109 8.57849C18.7108 10.7026 17.6513 12.5777 16.0332 13.7094C19.4185 15.1321 21.9131 18.5085 22.5488 22.5209C22.8193 24.2295 21.3875 25.5043 19.8633 25.5043H5.03711C3.51299 25.5042 2.08115 24.2294 2.35156 22.5209C2.98729 18.5085 5.48176 15.1312 8.86719 13.7084C7.25059 12.5766 6.19252 10.7016 6.19238 8.57849C6.19247 5.12177 8.99448 2.31894 12.4512 2.31873ZM12.4512 14.8383C12.4447 14.8383 12.4381 14.8373 12.4316 14.8373C8.40623 14.8477 4.91381 18.1898 4.18164 22.8109C4.12089 23.1966 4.44101 23.6526 5.03711 23.6527H19.8633C20.4595 23.6527 20.7795 23.1967 20.7188 22.8109C19.9865 18.1896 16.4944 14.8474 12.4688 14.8373C12.463 14.8373 12.457 14.8383 12.4512 14.8383ZM24.709 10.9857H27.1172V12.8373H24.709V15.2455H22.8574V12.8373H20.4502V10.9857H22.8574V8.57849H24.709V10.9857ZM12.4512 4.17029C10.0173 4.1705 8.04403 6.14458 8.04395 8.57849C8.04417 11.0123 10.0174 12.9855 12.4512 12.9857C14.8851 12.9857 16.8582 11.0124 16.8584 8.57849C16.8583 6.14445 14.8852 4.17029 12.4512 4.17029Z"
                    fill="url(#paint0_linear_5182_159309)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5182_159309"
                    x="-0.000346899"
                    y="1.93119e-05"
                    width="29.4362"
                    height="27.823"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15935" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5182_159309" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5182_159309" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278245" />
                    <feGaussianBlur stdDeviation="0.510115" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5182_159309" />
                </filter>
                <linearGradient id="paint0_linear_5182_159309" x1="2.31836" y1="21.8243" x2="28.7956" y2="10.3789" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysEarnIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none">
            <g filter="url(#filter0_di_5182_159340)">
                <path
                    d="M24.7461 2.31885C26.2574 2.31885 27.4833 3.5439 27.4834 5.05518V18.5942C27.4831 20.1054 26.2573 21.3306 24.7461 21.3306H5.05469C3.54357 21.3305 2.31863 20.1053 2.31836 18.5942V5.05518C2.31843 3.54394 3.54345 2.31892 5.05469 2.31885H24.7461ZM15.1396 13.7515C14.8068 14.0174 14.3316 14.0096 14.0068 13.7339L4.09863 5.31885V18.5942C4.0989 19.1218 4.52705 19.5492 5.05469 19.5493H24.7461C25.2738 19.5493 25.7019 19.1219 25.7021 18.5942V5.30615L15.1396 13.7515ZM14.6006 11.9009L24.3623 4.09912H5.41211L14.6006 11.9009Z"
                    fill="url(#paint0_linear_5182_159340)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5182_159340"
                    x="-0.000481129"
                    y="7.15256e-06"
                    width="29.8037"
                    height="23.6494"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5182_159340" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5182_159340" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5182_159340" />
                </filter>
                <linearGradient id="paint0_linear_5182_159340" x1="2.31836" y1="18.3131" x2="27.1119" y2="5.04945" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysShopIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="26" viewBox="0 0 30 26" fill="none">
            <g filter="url(#filter0_di_5184_159407)">
                <path
                    d="M25.252 7.56208C25.252 7.22852 24.9811 6.95758 24.6475 6.95758H8.24712L11.1456 16.9185C11.2205 17.1763 11.4563 17.3539 11.7247 17.3541H21.9747C22.2432 17.3541 22.4797 17.1764 22.5547 16.9185L25.2276 7.73005C25.2434 7.67545 25.252 7.61893 25.252 7.56208ZM27.3848 7.56208C27.3848 7.82072 27.3487 8.07838 27.2764 8.32673L24.6036 17.5152C24.2635 18.6839 23.1918 19.4879 21.9747 19.4879H11.7247C10.5077 19.4877 9.43683 18.6837 9.09673 17.5152L5.40532 4.82477H24.6475C26.1593 4.82477 27.3848 6.05032 27.3848 7.56208Z"
                    fill="url(#paint0_linear_5184_159407)"
                />
                <path
                    d="M4.79883 2.31885C5.9964 2.31899 7.05444 3.09749 7.41113 4.24072L8.34863 7.24463L6.31152 7.87939L5.375 4.87646C5.29634 4.62429 5.06296 4.45181 4.79883 4.45166H2.31836V2.31885H4.79883Z"
                    fill="url(#paint1_linear_5184_159407)"
                />
                <path
                    d="M11.6517 23.3853C12.3881 23.3853 12.985 22.7883 12.985 22.0519C12.985 21.3155 12.3881 20.7186 11.6517 20.7186C10.9153 20.7186 10.3184 21.3155 10.3184 22.0519C10.3184 22.7883 10.9153 23.3853 11.6517 23.3853Z"
                    fill="url(#paint2_linear_5184_159407)"
                />
                <path
                    d="M22.3184 23.3853C23.0547 23.3853 23.6517 22.7883 23.6517 22.0519C23.6517 21.3155 23.0547 20.7186 22.3184 20.7186C21.582 20.7186 20.985 21.3155 20.985 22.0519C20.985 22.7883 21.582 23.3853 22.3184 23.3853Z"
                    fill="url(#paint3_linear_5184_159407)"
                />
                <path d="M14.3085 10.083V14.2627H12.7089V10.083H14.3085Z" fill="url(#paint4_linear_5184_159407)" />
                <path d="M17.6497 10.083V14.2627H16.0501V10.083H17.6497Z" fill="url(#paint5_linear_5184_159407)" />
                <path d="M20.991 10.083V14.2627H19.3913V10.083H20.991Z" fill="url(#paint6_linear_5184_159407)" />
            </g>
            <defs>
                <filter
                    id="filter0_di_5184_159407"
                    x="-0.00048089"
                    y="7.39098e-06"
                    width="29.7041"
                    height="25.7041"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5184_159407" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5184_159407" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5184_159407" />
                </filter>
                <linearGradient id="paint0_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint1_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint2_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint3_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint4_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint5_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint6_linear_5184_159407" x1="-6.2698" y1="34.7853" x2="27.0733" y2="7.214" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysWarrantyIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5185_159614)">
                <path
                    d="M14.8857 2.59363C15.0239 2.57208 15.1664 2.58355 15.3008 2.62683L25.9512 6.05652C26.3228 6.17647 26.5752 6.52336 26.5752 6.91394V18.5692C26.5752 20.0548 26.2832 21.4749 25.7578 22.7772L26.5527 23.576C27.5935 24.6226 27.6589 26.2778 26.748 27.4003L26.5527 27.6171C25.4406 28.734 23.6353 28.7356 22.5225 27.6171L22.3145 27.4081C15.0668 33.3487 3.4028 28.2357 3.47559 18.5624V6.91394C3.47559 6.52319 3.72768 6.17632 4.09961 6.05652L14.749 2.62683L14.8857 2.59363ZM5.27539 7.56921V18.576C5.21518 26.5841 14.8991 30.9752 21.0381 26.1249L16.0439 21.1024C13.8835 21.8017 11.4187 21.2933 9.70215 19.5682C7.73092 17.5853 7.35607 14.6101 8.56836 12.2489C8.68529 12.0216 8.90371 11.8635 9.15625 11.8241C9.40922 11.7848 9.66614 11.8692 9.84668 12.0507L11.4453 13.6581L12.6631 12.4335L11.0586 10.8202C10.8792 10.6398 10.797 10.3841 10.8359 10.1327C10.8752 9.88116 11.0319 9.6631 11.2578 9.54578C13.6116 8.32443 16.5743 8.70305 18.5479 10.6874C20.2653 12.4143 20.7678 14.8905 20.0713 17.0594L24.3525 21.3641C24.6259 20.4806 24.7754 19.5424 24.7754 18.5692V7.56921L15.0244 4.42859L5.27539 7.56921ZM17.4141 11.8153C16.2346 10.6294 14.5796 10.2142 13.0664 10.5692L14.3594 11.869C14.6696 12.1811 14.6697 12.6859 14.3594 12.9979L12.0127 15.3573C11.8627 15.5078 11.6588 15.5925 11.4463 15.5927C11.2336 15.5926 11.029 15.508 10.8789 15.3573L9.5957 14.0673C9.24489 15.5904 9.65873 17.2551 10.8369 18.4403L11.1025 18.6874C12.4674 19.8629 14.3492 20.1132 15.9365 19.4384L16.0508 19.3993C16.3223 19.3298 16.6146 19.4073 16.8164 19.6102L23.6553 26.4882H23.6562C24.1429 26.9773 24.9315 26.9775 25.4189 26.4882C25.9078 25.9962 25.9078 25.197 25.4189 24.705L18.5781 17.827C18.3497 17.5972 18.2828 17.2518 18.4082 16.953C19.1257 15.2455 18.7932 13.2022 17.4141 11.8153Z"
                    fill="url(#paint0_linear_5185_159614)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5185_159614"
                    x="1.1559"
                    y="0.264302"
                    width="28.5476"
                    height="32.0008"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15935" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159614" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159614" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278245" />
                    <feGaussianBlur stdDeviation="0.510115" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159614" />
                </filter>
                <linearGradient id="paint0_linear_5185_159614" x1="-2.43725" y1="30.8748" x2="31.0522" y2="17.0598" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysProfileIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g filter="url(#filter0_di_5182_159364)">
                <path
                    d="M15.5049 8.49707H7.12207C6.60856 8.49714 6.19148 8.91422 6.19141 9.42773V22.6006C6.19152 23.1141 6.60859 23.5312 7.12207 23.5312H25.085C25.5984 23.5312 26.0145 23.114 26.0146 22.6006V21.4033H27.748V22.6006C27.7479 24.071 26.5554 25.2636 25.085 25.2637H7.12207C5.65167 25.2636 4.4591 24.071 4.45898 22.6006V9.42773C4.45905 7.9573 5.65164 6.7657 7.12207 6.76562H15.5049V8.49707ZM22.0908 20.4727H10.1152V18.7402H22.0908V20.4727ZM20.9229 6.09863C23.3851 6.09886 25.3815 8.09447 25.3818 10.5566C25.3818 11.9073 24.7798 13.1168 23.8311 13.9346C25.4499 14.6687 26.8514 15.9745 27.6826 17.5986L26.1396 18.3877C25.1044 16.3656 22.9641 15.0168 20.9238 15.0166C19.8101 15.0166 19.03 15.1744 18.4072 15.4307C17.7842 15.6871 17.2629 16.0647 16.6865 16.5879L15.5215 15.3057C16.1763 14.7113 16.8673 14.1903 17.7471 13.8281C17.7814 13.814 17.8169 13.8016 17.8516 13.7881C16.9973 12.9757 16.4639 11.8286 16.4639 10.5566C16.4642 8.09442 18.4606 6.09877 20.9229 6.09863ZM13.708 14.4854H10.1152V12.7529H13.708V14.4854ZM20.9229 7.83105C19.4175 7.8312 18.1966 9.05134 18.1963 10.5566C18.1963 12.0622 19.4173 13.284 20.9229 13.2842C22.4283 13.284 23.6494 12.0622 23.6494 10.5566C23.6491 9.05139 22.4281 7.83128 20.9229 7.83105Z"
                    fill="url(#paint0_linear_5182_159364)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5182_159364"
                    x="2.14014"
                    y="3.77979"
                    width="27.9267"
                    height="23.8027"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5182_159364" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5182_159364" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5182_159364" />
                </filter>
                <linearGradient id="paint0_linear_5182_159364" x1="-3.52021" y1="35.6348" x2="26.9271" y2="9.92255" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysInvitedIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5184_159415)">
                <path
                    d="M5.52189 7.45817C8.13701 4.84305 12.3765 4.84305 14.9916 7.45817L16.0219 8.48844L16.9955 7.53043C19.635 4.93278 23.8759 4.94989 26.4945 7.56852C29.0432 10.1173 29.0842 14.2241 26.6176 16.8234L26.6068 16.8341L26.4545 16.9894L26.4486 16.9943L26.4438 17.0002L24.8783 18.5314L24.8334 18.5744L17.5453 25.8644C16.6928 26.7169 15.3099 26.7169 14.4574 25.8644L5.52189 16.9279C2.90677 14.3128 2.90677 10.0733 5.52189 7.45817ZM13.8197 8.63004C11.852 6.66234 8.66147 6.66234 6.69376 8.63004C4.72606 10.5977 4.72606 13.7883 6.69376 15.756L15.6303 24.6916C15.8354 24.8966 16.1674 24.8966 16.3725 24.6916L23.1264 17.9377L20.307 15.1193L18.8822 16.5324C17.4465 17.9566 15.1298 17.9524 13.6996 16.5226L13.5483 16.3703C12.0791 14.9011 12.0447 12.5414 13.4457 11.0304L13.4526 11.0236L13.4584 11.0168L13.5561 10.9162L13.5697 10.9025L14.8402 9.65055L13.8197 8.63004ZM25.3217 8.74039C23.3468 6.76587 20.1491 6.75321 18.1586 8.71207L14.7328 12.0841L14.7318 12.0832L14.6606 12.1564L14.6615 12.1574C13.8642 13.0173 13.8836 14.3618 14.7201 15.1984L14.8715 15.3498C15.6561 16.1343 16.9275 16.1371 17.7152 15.3556L19.4067 13.6779L19.5043 13.59C20.0072 13.1832 20.746 13.2139 21.2133 13.6808L24.3051 16.7726L25.2836 15.8156L25.4145 15.6818C27.2642 13.7326 27.2334 10.6521 25.3217 8.74039ZM7.46818 9.40445C8.84946 8.02317 11.0888 8.02317 12.4701 9.40445C12.7938 9.72817 12.7938 10.2526 12.4701 10.5763C12.1464 10.8998 11.6219 10.8999 11.2983 10.5763C10.5644 9.84252 9.37491 9.84263 8.64103 10.5763C7.90716 11.3102 7.90716 12.4997 8.64103 13.2336C8.96466 13.5573 8.96468 14.0827 8.64103 14.4064C8.31734 14.7301 7.79189 14.7301 7.46818 14.4064C6.087 13.0252 6.08721 10.7858 7.46818 9.40445Z"
                    fill="url(#paint0_linear_5184_159415)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5184_159415"
                    x="1.24171"
                    y="3.17799"
                    width="29.5146"
                    height="25.6446"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5184_159415" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5184_159415" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5184_159415" />
                </filter>
                <linearGradient id="paint0_linear_5184_159415" x1="-4.96261" y1="37.8717" x2="28.2563" y2="10.5339" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightIns() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5185_159595)">
                <path
                    d="M22.25 4.10254C25.3678 4.10254 27.8955 6.6312 27.8955 9.74902V22.252C27.8952 25.3696 25.3677 27.8975 22.25 27.8975H9.74707C6.62941 27.8975 4.10183 25.3696 4.10156 22.252V9.74902C4.10156 6.6312 6.62924 4.10254 9.74707 4.10254H22.25ZM9.74707 5.39062C7.34035 5.39062 5.38867 7.34231 5.38867 9.74902V22.252C5.38894 24.6585 7.34052 26.6104 9.74707 26.6104H22.25C24.6566 26.6104 26.6081 24.6585 26.6084 22.252V9.74902C26.6084 7.34231 24.6567 5.39062 22.25 5.39062H9.74707ZM15.999 10.0264C19.2984 10.0266 21.9727 12.7016 21.9727 16.001C21.9721 19.2999 19.2981 21.9744 15.999 21.9746C12.6998 21.9746 10.0249 19.3001 10.0244 16.001C10.0244 12.7014 12.6995 10.0264 15.999 10.0264ZM15.999 11.3135C13.4106 11.3135 11.3115 13.4125 11.3115 16.001C11.312 18.589 13.4109 20.6875 15.999 20.6875C18.5869 20.6872 20.685 18.5888 20.6855 16.001C20.6855 13.4127 18.5873 11.3137 15.999 11.3135ZM22.7861 7.97949C23.4674 7.97973 24.0195 8.53252 24.0195 9.21387C24.0193 9.89501 23.4673 10.447 22.7861 10.4473C22.1048 10.4473 21.552 9.89516 21.5518 9.21387C21.5518 8.53237 22.1046 7.97949 22.7861 7.97949Z"
                    fill="url(#paint0_linear_5185_159595)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5185_159595"
                    x="1.78272"
                    y="1.7837"
                    width="28.4306"
                    height="28.4326"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159595" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159595" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159595" />
                </filter>
                <linearGradient id="paint0_linear_5185_159595" x1="1.19306" y1="28.8332" x2="30.5978" y2="14.6364" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
export function RightX() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5185_159583)">
                <path
                    d="M17.8772 14.4912L25.2181 6.14148H23.4788L17.1018 13.3899L12.0122 6.14148H6.14062L13.8388 17.1034L6.14062 25.8586H7.87996L14.6101 18.2022L19.9861 25.8586H25.8577L17.8772 14.4912ZM15.4942 17.1996L14.713 16.1074L8.5072 7.42453H11.1792L16.1889 14.4345L16.9668 15.5267L23.478 24.638H20.806L15.4942 17.1996Z"
                    fill="url(#paint0_linear_5185_159583)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5185_159583"
                    x="3.95343"
                    y="3.95429"
                    width="24.0912"
                    height="24.0915"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.0936" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159583" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159583" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.304287" />
                    <feGaussianBlur stdDeviation="0.328079" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159583" />
                </filter>
                <linearGradient id="paint0_linear_5185_159583" x1="-2.49851" y1="31.3835" x2="28.0203" y2="14.492" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
export function RightYoutube() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5185_159590)">
                <path
                    d="M14.0605 13.1581V18.8518C14.0605 19.1582 14.309 19.4066 14.6153 19.4066C14.7241 19.4066 14.8305 19.3746 14.9213 19.3146L19.1915 16.4923C19.4471 16.3233 19.5173 15.9791 19.3484 15.7235C19.308 15.6624 19.2559 15.6099 19.1951 15.569L14.9249 12.6977C14.6706 12.5267 14.3259 12.5943 14.1549 12.8485C14.0934 12.9401 14.0605 13.0478 14.0605 13.1581Z"
                    fill="url(#paint0_linear_5185_159590)"
                />
                <path
                    d="M27.4971 15.9503C27.4971 14.4829 27.4167 12.7762 27.2539 10.8282C27.1251 9.28925 25.8775 8.08302 24.335 8.00598C20.7501 7.82738 17.9738 7.73841 16 7.7384C14.0265 7.7384 11.2512 7.82738 7.66797 8.00598C6.12573 8.08286 4.87836 9.28858 4.74902 10.8273C4.58403 12.7901 4.50197 14.4968 4.50195 15.9503C4.50195 17.4216 4.58584 19.1526 4.75488 21.1456C4.88378 22.6652 6.10417 23.8625 7.62598 23.962C10.6792 24.1617 13.4704 24.2618 16 24.2618C18.53 24.2618 21.3222 24.1618 24.377 23.962C25.8991 23.8623 27.1197 22.6647 27.248 21.1447C27.4149 19.1668 27.4971 17.4359 27.4971 15.9503ZM29.0977 15.9503C29.0977 17.4923 29.0113 19.27 28.8418 21.2794C28.6468 23.5881 26.7934 25.4073 24.4814 25.5587C21.3987 25.7603 18.571 25.8614 16 25.8615C13.4293 25.8615 10.6026 25.7602 7.52148 25.5587C5.21007 25.4075 3.35601 23.5894 3.16016 21.2814C2.98848 19.2574 2.90234 17.4791 2.90234 15.9503C2.90236 14.4401 2.98674 12.6869 3.1543 10.6935C3.35074 8.35647 5.24558 6.52429 7.58789 6.40735C11.1803 6.22829 13.9869 6.13879 16 6.13879C18.0133 6.1388 20.8202 6.22928 24.4141 6.40833C26.7574 6.5251 28.6532 8.35736 28.8486 10.6954C29.0141 12.6746 29.0976 14.4271 29.0977 15.9503Z"
                    fill="url(#paint1_linear_5185_159590)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5185_159590"
                    x="0.583503"
                    y="3.81995"
                    width="30.833"
                    height="24.3603"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159590" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159590" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159590" />
                </filter>
                <linearGradient id="paint0_linear_5185_159590" x1="-0.2997" y1="26.6371" x2="27.987" y2="8.4981" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint1_linear_5185_159590" x1="-0.2997" y1="26.6371" x2="27.987" y2="8.4981" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
export function RightFacebook() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect opacity="0.01" width="32" height="32" fill="black" />
            <g filter="url(#filter0_di_5185_159577)">
                <path
                    d="M26.0371 15.5993C26.0371 14.2053 25.7721 12.9067 25.2451 11.696C24.7111 10.4692 23.9919 9.40666 23.0889 8.50262C22.1865 7.59934 21.1263 6.88418 19.9023 6.35712C18.6922 5.83601 17.3938 5.57294 16 5.57294C14.6063 5.57296 13.3078 5.83603 12.0977 6.35712C10.8739 6.88414 9.81438 7.59948 8.91211 8.50262C8.00895 9.4067 7.28993 10.4691 6.75586 11.696C6.22882 12.9068 5.96289 14.2052 5.96289 15.5993C5.9629 16.9934 6.2288 18.2918 6.75586 19.5026C7.28993 20.7295 8.00896 21.7919 8.91211 22.696C9.81522 23.6 10.8762 24.3197 12.1016 24.8542C13.3109 25.3816 14.6077 25.6471 16 25.6472C17.3924 25.6472 18.69 25.3817 19.8994 24.8542C21.1247 24.3197 22.1858 23.6 23.0889 22.696C23.992 21.7919 24.7111 20.7294 25.2451 19.5026C25.7721 18.2919 26.0371 16.9933 26.0371 15.5993ZM27.5371 15.5993C27.5371 17.1899 27.233 18.6931 26.6201 20.1013C26.0141 21.4935 25.1903 22.7146 24.1494 23.7565C23.1086 24.7983 21.8898 25.6225 20.499 26.2292C19.092 26.8429 17.5894 27.1472 16 27.1472C14.4108 27.1471 12.9088 26.8428 11.502 26.2292C10.1111 25.6225 8.89145 24.7984 7.85059 23.7565C6.80968 22.7146 5.98594 21.4935 5.37988 20.1013C4.76699 18.6932 4.4629 17.1898 4.46289 15.5993C4.46289 14.0088 4.76701 12.5054 5.37988 11.0974C5.98594 9.70511 6.80968 8.48405 7.85059 7.44208C8.89219 6.39947 10.1126 5.57873 11.5049 4.97919C12.9111 4.37366 14.412 4.07296 16 4.07294C17.588 4.07294 19.0889 4.37372 20.4951 4.97919C21.8874 5.57869 23.1078 6.39955 24.1494 7.44208C25.1903 8.48405 26.0141 9.70511 26.6201 11.0974C27.233 12.5055 27.5371 14.0087 27.5371 15.5993Z"
                    fill="url(#paint0_linear_5185_159577)"
                />
            </g>
            <g filter="url(#filter1_di_5185_159577)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8286 12.2741H17.2281C17.1258 12.2741 17.0307 12.3326 16.943 12.4497C16.8553 12.5667 16.8115 12.7057 16.8115 12.8667V14.0519H18.8286L18.5436 15.7199H16.8115V20.724H14.904V15.7199H13.1719V14.0519H14.904V13.0642C14.904 12.3619 15.1232 11.7583 15.5617 11.2535C16.0003 10.7487 16.5557 10.4963 17.2281 10.4963H18.8286V12.2741Z"
                    fill="url(#paint1_linear_5185_159577)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5185_159577"
                    x="2.14405"
                    y="1.7541"
                    width="27.7119"
                    height="27.7119"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15942" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159577" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159577" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159577" />
                </filter>
                <filter
                    id="filter1_di_5185_159577"
                    x="11.4719"
                    y="8.79634"
                    width="9.05625"
                    height="13.6276"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.85" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5185_159577" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5185_159577" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.35" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5185_159577" />
                </filter>
                <linearGradient id="paint0_linear_5185_159577" x1="-9.25354" y1="43.7835" x2="31.7462" y2="16.0014" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
                <linearGradient id="paint1_linear_5185_159577" x1="7.07847" y1="30.5193" x2="23.8279" y2="25.1879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
export function RightFollow() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="27" viewBox="0 0 30 27" fill="none">
            <g filter="url(#filter0_di_5243_445484)">
                <path
                    d="M25.8008 13.216C25.8007 7.7516 21.3363 3.30012 15.8438 3.29999H13.2588C7.76628 3.29999 3.30193 7.75152 3.30181 13.216C3.30181 15.6605 4.18275 17.9693 5.79693 19.7844L6.26568 20.3117L3.46197 23.133H15.8438C21.3363 23.1329 25.8008 18.6806 25.8008 13.216ZM27.3008 13.216C27.3008 19.5143 22.1594 24.6329 15.8438 24.633H3.19146C2.63207 24.633 2.12543 24.2983 1.90826 23.7824L1.90728 23.7795C1.69314 23.2643 1.80635 22.666 2.20709 22.2668L4.22466 20.2365C2.65535 18.2378 1.80181 15.7902 1.80181 13.216C1.80193 6.91767 6.94329 1.79999 13.2588 1.79999H15.8438C22.1593 1.80012 27.3007 6.91775 27.3008 13.216Z"
                    fill="url(#paint0_linear_5243_445484)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5243_445484"
                    x="0.000781298"
                    y="-1.21593e-05"
                    width="29.1"
                    height="26.433"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.9" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5243_445484" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5243_445484" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5243_445484" />
                </filter>
                <linearGradient id="paint0_linear_5243_445484" x1="-1.31628" y1="25.5309" x2="28.7897" y2="9.29777" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightKakoo() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="27" viewBox="0 0 30 27" fill="none">
            <g filter="url(#filter0_di_5243_445481)">
                <path
                    d="M25.8008 13.216C25.8007 7.7516 21.3363 3.30012 15.8438 3.29999H13.2588C7.76628 3.29999 3.30193 7.75152 3.30181 13.216C3.30181 15.6605 4.18275 17.9693 5.79693 19.7844L6.26568 20.3117L3.46197 23.133H15.8438C21.3363 23.1329 25.8008 18.6806 25.8008 13.216ZM27.3008 13.216C27.3008 19.5143 22.1594 24.6329 15.8438 24.633H3.19146C2.63207 24.633 2.12543 24.2983 1.90826 23.7824L1.90728 23.7795C1.69314 23.2643 1.80635 22.666 2.20709 22.2668L4.22466 20.2365C2.65535 18.2378 1.80181 15.7902 1.80181 13.216C1.80193 6.91767 6.94329 1.79999 13.2588 1.79999H15.8438C22.1593 1.80012 27.3007 6.91775 27.3008 13.216Z"
                    fill="url(#paint0_linear_5243_445481)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_5243_445481"
                    x="0.000781298"
                    y="-1.21593e-05"
                    width="29.1"
                    height="26.433"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.9" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5243_445481" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5243_445481" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.278261" />
                    <feGaussianBlur stdDeviation="0.510145" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_5243_445481" />
                </filter>
                <linearGradient id="paint0_linear_5243_445481" x1="-1.31628" y1="25.5309" x2="28.7897" y2="9.29777" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />
                    <stop offset="0.504808" stopColor="#98780D" />
                    <stop offset="0.985577" stopColor="#D2AB4F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

// 社区发帖图标
export function RightCommunityPost({ size = '23', fill = 'url(#prefix_dxc-svg-to-react_b)', ...other }) {
    return (
        <svg width={size} height={size} viewBox="0 0 29 29" fill="none" {...other}>
            <g filter="url(#a)">
                <path
                    d="M20.989 14.983a.867.867 0 0 1 1.16.06l3.918 3.92a.866.866 0 0 1 0 1.224l-5.879 5.878a.866.866 0 0 1-.612.254h-3.92a.866.866 0 0 1-.866-.866v-3.92c0-.23.092-.45.254-.612l5.88-5.878.065-.06Zm-4.466 6.909v2.695h2.695l5.012-5.014-2.695-2.693-5.012 5.012Zm-4.33-5.717a.866.866 0 0 1 0 1.732H8.037a.866.866 0 0 1 0-1.732h4.158Zm4.157-4.157a.866.866 0 0 1 0 1.732H8.036a.867.867 0 0 1 0-1.732h8.314Zm3.984-.52v-5.54a1.906 1.906 0 0 0-1.906-1.906H5.958a1.906 1.906 0 0 0-1.906 1.906v16.626c0 1.052.854 1.906 1.906 1.906H11.5a.866.866 0 0 1 0 1.732H5.958a3.638 3.638 0 0 1-3.638-3.638V5.957a3.638 3.638 0 0 1 3.638-3.638h12.47a3.638 3.638 0 0 1 3.638 3.638v5.542a.866.866 0 0 1-1.732 0ZM16.35 7.862a.866.866 0 0 1 0 1.732H8.036a.866.866 0 0 1 0-1.732h8.314Z"
                    fill="url(#b)"
                />
            </g>
            <defs>
                <linearGradient id="b" x1="2.32" y1="31.398" x2="29.661" y2="13.248" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />

                    <stop offset="0.505" stopColor="#98780D" />

                    <stop offset="0.986" stopColor="#D2AB4F" />
                </linearGradient>
                <filter id="a" x="0.001" y="0" width="28.638" height="28.638" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset />

                    <feGaussianBlur stdDeviation="1.159" />

                    <feComposite in2="hardAlpha" operator="out" />

                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />

                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3917_36277" />

                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3917_36277" result="shape" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset dx="0.278" />

                    <feGaussianBlur stdDeviation="0.51" />

                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />

                    <feColorMatrix values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />

                    <feBlend in2="shape" result="effect2_innerShadow_3917_36277" />
                </filter>
            </defs>
        </svg>
    );
}

// 社区评论图标
export function RightCommunityComment({ size = '23', fill = 'url(#prefix_dxc-svg-to-react_b)', ...other }) {
    return (
        <svg width={size} height={size} viewBox="0 0 29 29" fill="none" {...other}>
            <g filter="url(#a)">
                <path
                    d="M24.57 5.975a1.906 1.906 0 0 0-1.906-1.906H5.977A1.906 1.906 0 0 0 4.07 5.975V16.86c0 1.052.853 1.904 1.906 1.904h5.562c.337 0 .644.194.79.498l2.024 4.225 2.214-4.25.063-.104a.877.877 0 0 1 .713-.369h5.32a1.906 1.906 0 0 0 1.907-1.904V5.975Zm-5.692 7.469a.875.875 0 1 1 0 1.75H9.685a.875.875 0 1 1 0-1.75h9.193Zm0-4.636a.875.875 0 1 1 0 1.75H9.685a.875.875 0 1 1 0-1.75h9.193Zm7.442 8.05a3.656 3.656 0 0 1-3.656 3.657h-4.789l-2.778 5.333a.875.875 0 0 1-1.566-.026l-2.544-5.307h-5.01a3.656 3.656 0 0 1-3.657-3.656V5.975A3.656 3.656 0 0 1 5.977 2.32h16.687a3.656 3.656 0 0 1 3.656 3.656V16.86Z"
                    fill="url(#b)"
                />
            </g>
            <defs>
                <linearGradient id="b" x1="2.32" y1="31.398" x2="29.661" y2="13.248" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />

                    <stop offset="0.505" stopColor="#98780D" />

                    <stop offset="0.986" stopColor="#D2AB4F" />
                </linearGradient>
                <filter id="a" x="0.001" y="0" width="28.638" height="28.638" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset />

                    <feGaussianBlur stdDeviation="1.159" />

                    <feComposite in2="hardAlpha" operator="out" />

                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />

                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3917_35988" />

                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3917_35988" result="shape" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset dx="0.278" />

                    <feGaussianBlur stdDeviation="0.51" />

                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />

                    <feColorMatrix values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />

                    <feBlend in2="shape" result="effect2_innerShadow_3917_35988" />
                </filter>
            </defs>
        </svg>
    );
}
// 社区点赞图标
export function RightCommunityLike({ width = '23', height = '21', fill = 'url(#prefix_dxc-svg-to-react_b)', ...other }) {
    return (
        <svg width={width} height={height} viewBox="0 0 29 28" fill="none" {...other}>
            <g filter="url(#a)">
                <path
                    d="M16.574 2.319a2.178 2.178 0 0 1 2.109 2.726l-1.186 4.556a.428.428 0 0 0 .414.536h6.163c1.183 0 2.15.944 2.178 2.127l.05 2.155a2.18 2.18 0 0 1-.143.832l-3.174 8.269a2.179 2.179 0 0 1-2.034 1.398H4.498A2.178 2.178 0 0 1 2.32 22.74V12.405c0-1.203.975-2.178 2.178-2.178h3.304l5.803-7.107a2.179 2.179 0 0 1 1.687-.801h1.282Zm-1.282 1.75a.429.429 0 0 0-.332.157l-6.065 7.43a.874.874 0 0 1-.264.216v11.296h12.32a.43.43 0 0 0 .4-.275l3.173-8.27a.43.43 0 0 0 .029-.163l-.051-2.155a.428.428 0 0 0-.428-.418h-6.163a2.179 2.179 0 0 1-2.108-2.726l1.185-4.556a.428.428 0 0 0-.414-.536h-1.282ZM4.07 22.739c0 .237.192.428.428.428h2.383v-11.19H4.498a.428.428 0 0 0-.428.428V22.74Z"
                    fill="url(#b)"
                />
            </g>
            <defs>
                <linearGradient id="b" x1="2.32" y1="29.7" x2="28.626" y2="11.168" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DFBA60" />

                    <stop offset="0.505" stopColor="#98780D" />

                    <stop offset="0.986" stopColor="#D2AB4F" />
                </linearGradient>
                <filter id="a" x="0.001" y="0" width="28.622" height="27.236" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset />

                    <feGaussianBlur stdDeviation="1.159" />

                    <feComposite in2="hardAlpha" operator="out" />

                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />

                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3917_35916" />

                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3917_35916" result="shape" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset dx="0.278" />

                    <feGaussianBlur stdDeviation="0.51" />

                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />

                    <feColorMatrix values="0 0 0 0 0.307529 0 0 0 0 0.258443 0 0 0 0 0.0621 0 0 0 0.66 0" />

                    <feBlend in2="shape" result="effect2_innerShadow_3917_35916" />
                </filter>
            </defs>
        </svg>
    );
}
